import ko from 'knockout'
import moment from 'moment';
import { formatDecimal } from '../../decimal-utils';
import { CustomError, customFetch as fetch } from '../../fetch';
import { openPopup, closePopups } from '../../init';
import debounce from 'lodash.debounce';

interface EditEmployeeVacationRequestOptions {
    refresh(model: EditEmployeeVacationRequestModel): void;
    postLocation: string;
    employeeId?: string;
}

class EditEmployeeVacationRequestModel {
    error: KnockoutObservable<string>;
    saving: KnockoutObservable<boolean>;

    id: KnockoutObservable<string>;
    from: KnockoutObservable<moment.Moment>;
    to: KnockoutObservable<moment.Moment>;
    vacationHours: KnockoutObservable<number>;

    isSpecialLeave: KnockoutObservable<boolean>;
    reason: KnockoutObservable<string>;

    validationErrors: KnockoutObservableArray<CustomError>;

    options: EditEmployeeVacationRequestOptions;

    constructor(options: EditEmployeeVacationRequestOptions) {
        this.validationErrors = ko.observableArray<CustomError>();
        this.saving = ko.observable<boolean>();
        this.isSpecialLeave = ko.observable<boolean>(false);

        this.id = ko.observable<string>();
        this.from = ko.observable<moment.Moment>(moment())
            .extend({
                errorHandler: { source: this.validationErrors, id: 'From' }
            });
        this.to = ko.observable<moment.Moment>(moment())
            .extend({
                errorHandler: { source: this.validationErrors, id: 'To' }
            });

        this.vacationHours = ko.observable<number>(0)
            .extend({
                errorHandler: { source: this.validationErrors, id: 'VacationHours' }
            });

        this.error = ko.observable<string>()
            .extend({
                errorHandler: { source: this.validationErrors, id: 'Error' }
            });

        this.reason = ko.observable<string>()
            .extend({
                errorHandler: { source: this.validationErrors, id: 'Reason' }
            });

        this.options = options;
    }

    debouncedSubmit = debounce(async () => this.submit(), 250);

    async submit() {
        const fd = new FormData();

        if (this.from()) {
            fd.append('from', this.from().format('YYYY-MM-DD HH:mm'));
        }

        if (this.to()) {
            fd.append('to', this.to().format('YYYY-MM-DD HH:mm'));
        }

        fd.append('vacationHours', formatDecimal(this.vacationHours()));
        fd.append('isSpecialLeave', this.isSpecialLeave().toString());

        if (this.options.employeeId) {
            fd.append('employeeId', this.options.employeeId);
        }
        
        fd.append('reason', this.reason() || '');
        

        this.saving(true);

        const url = `${this.options.postLocation}/${this.id()}`;
        const response = await fetch(url, {
            method: 'POST',
            body: fd
        });

        this.saving(false);

        if (response.ok) {
            this.options.refresh(this);
            this.reset();
            this.closePopup();
        } else if (response.data.length > 0) {
            this.validationErrors(response.data);
        } else {
            if (response.errors && response.errors.length > 0) {
                this.validationErrors(response.errors);
            }
        }
    }

    reset() {
        this.from(null);
        this.to(null);
        this.vacationHours(null);
        this.validationErrors([]);
    }

    openEdit(item: any) {
        this.id(item.id);
        this.from(moment(item.from));
        this.to(moment(item.to));
        this.vacationHours(item.vacationHours);
        this.reason(item.reason);
        openPopup('edit-vacation');
    }

    closePopup() {
        closePopups();
    }
}

export default EditEmployeeVacationRequestModel;
